import { API_URL, BASE_URL } from "./WebServiceUrl";

const webServiceGateWay = "https://web1024.docmaster.in:8443/";
const wsOrganisation = "organisation";
export const WSRegistration = `${BASE_URL}/api/adminauth/registration`;
export const WSGetOrgUsers = `${BASE_URL}/api/auth/users`;
export const WSGetDocFormFieldsTemplate = `${BASE_URL}/organization/getDocFormFieldsTemplate`;
export const WSGetDocFormFieldsTemplate2 = `${BASE_URL}/studentdoc/getDocFormFieldsTemplate`;
export const WSGetMyFilledOrgDocForm = `${BASE_URL}/organization/getMyFilledOrgDocForm`;
export const WSGetMyFilledOrgDocForm2 = `${BASE_URL}/studentdoc/getMyFilledOrgDocForm`;

export const WSPutOrgDocFormUserInputData = `${BASE_URL}/organization/putOrgDocFormUserInputData`;
export const WSPutOrgDocFormUserInputData2 = `${BASE_URL}/studentdoc/putOrgDocFormUserInputData`;
export const WsGetOrgUserPreFillField = `${BASE_URL}/organization/getOrgUserPreFillField`;
export const WsGetOrgUserPreFillField2 = `${BASE_URL}/studentdoc/getOrgUserPreFillField`;

export const GetHolidayExcludeForms = `${API_URL}/autoFill/getHolidaysExcludeForms`;

export const WsGetOrgUsersByDepartment =
  webServiceGateWay + wsOrganisation + "/getOrgUsersByDepartment";
export const WsRemoveUser = webServiceGateWay + wsOrganisation + "/removeUser";
export const WsDeleteOrgUserDepartmentMap =
  webServiceGateWay + wsOrganisation + "/deleteOrgUserDepartmentMap";

export const addDocFormData = `${API_URL}/govtBulletinBoard/docform-draft-data`;
export const WsPutOrgUserDepartmentMap =
  webServiceGateWay + wsOrganisation + "/putOrgUserDepartmentMap";
export const WSAddUser = webServiceGateWay + wsOrganisation + "/addUser";
export const GetAutoFillData = `${API_URL}/autoFill/getData`;
export const WSGetMyFilledOrgDocForms = `${BASE_URL}/organization/getMyFilledOrgDocForms`;
export const WSGetMyFilledOrgDocForms2 = `${BASE_URL}/studentdoc/getMyFilledOrgDocForms`;
export const WSDeleteMyFilledOrgDocForm = `${BASE_URL}/organization/deleteMyFilledOrgDocForm`;
export const WSDeleteMyFilledOrgDocForm2 = `${BASE_URL}/studentdoc/deleteMyFilledOrgDocForm`;

export const getEvents = `${BASE_URL}/event-org/events-activities1`;

export const getActivityDetails = `${BASE_URL}/event-org/activity-details`;

export const WSDeleteItemProductForCosting =
  "http://localhost:5001/dc_item_product_for_costing/deleteItemProductForCosting";

export const WSPutCostSheetMasterAndOtherItems = `${BASE_URL}/cost-sheet/putCostSheetMasterAndOtherItems`;

export const WSGetCostSheetMasterAndOtherItems = `${BASE_URL}/cost-sheet/getCostSheetMasterAndOtherItems`;

export const WsGetCostSheets = `${BASE_URL}/cost-sheet/getCostSheets`;

export const WsPutCostSheet = `${BASE_URL}/cost-sheet/putCostSheet`;

export const MapCostSheetActivity = `${BASE_URL}/cost-sheet/mapCostSheetActivity`;

export const UploadDocument = `${BASE_URL}/eo-upload/uploadFiles`;

export const getUploadedDocumentDetails = `${BASE_URL}/eo-upload/uploadFiles/`;

export const updateStatus = `${BASE_URL}/cost-sheet/update-status`;

export const addNewComment = `${BASE_URL}/event-org/create-activity-comment1`;

export const generateSummary = `${BASE_URL}/quoteSummary/generate-ai-summary`;

export const AddEventDocForm = `${BASE_URL}/event-org/docform-draftdata`;

export const viewGenerateComplaintsApi =
  "https://web1024.docmaster.in:5002/doc/generate-compliant-doc";

export const userRole = `${API_URL}/userRole/user-role`;
export const getPublishedDocuments = `${API_URL}/content/getPublishedDocuments`;

export const createEventActivity = `${BASE_URL}/event-org/create-event-activities`;
export const createTask = `${BASE_URL}/event-org/tasks`;
export const GetActivityTasks = `${BASE_URL}/event-org/tasks`;
export const updateAssignedUser = `${BASE_URL}/event-org/tasks/update-assigned-users`;
export const updateTaskstatus = `${BASE_URL}/event-org/tasks/update-status`;
export const userLogin = `${BASE_URL}/api/adminauth/login`;
export const userLogout = `${BASE_URL}/api/adminauth/logout`;
export const userForceLogoutAll = `${BASE_URL}/api/adminauth/logout-all-device`;

export const userCrudAccess = `${BASE_URL}/api/auth/user-crud-access`;
export const getUserCrudAccess = `${BASE_URL}/api/auth/user-crud-access`;
export const createMaster = `${BASE_URL}/masterdata/create-master`;
export const masterData = `${BASE_URL}/masterdata/master-data`;
export const userPrefill = `${BASE_URL}/prefill`;
export const userPrefill2 = `${BASE_URL}/studentdoc/prefill`;
export const myProjects = `${BASE_URL}/project`;
export const teacherPlanner = `${BASE_URL}/teacher-planner`;
export const lessonPlanner = `${BASE_URL}/topic`;
export const userAccessAPI = `${BASE_URL}/userAccess/getCounts/`;
export const userAccessAPI2 = `${BASE_URL}/studentdoc/userAccess/getCounts/`;
export const GetCountRestrictionsAPI = `${BASE_URL}/userAccess/getCountRestrictions/`;
export const GetCountRestrictionsAPI2 = `${BASE_URL}/studentdoc/userAccess/getCountRestrictions/`;

export const generateOtp = `${BASE_URL}/api/adminauth/sendotp`;
export const guestEmailOtp = `${BASE_URL}/api/adminauth/sendotp-update`;
export const generateMobOtp = `${BASE_URL}/api/adminauth/sendOTPMobileNo`;
export const verifyOtp = `${BASE_URL}/api/adminauth/verifiedotp`;
export const verifymobOtp = `${BASE_URL}/api/adminauth/verifiedotpmob`;
export const UserAIIntegration =
  "https://web1024.docmaster.in:5007/competition";
//export const UserAIIntegration = "http://localhost:5007/competition";
export const lclUserAIIntegration = "http://localhost:5007/competition";
// export const lessonPlanner = `http://localhost:5010/topic`;
export const studentClasses =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin/classes";
export const getQuestionPapers = `${BASE_URL}/api/questionPaper/other-question-banks`;

export const boardsAPI =
  "https://web1024.docmaster.in:5007/api/board/all-boards";
export const boardsBasedMediumAPI =
  "https://web1024.docmaster.in:5007/api/board/mediums-by-board/";

export const boardAndMediumBasedClassesAPI =
  "https://web1024.docmaster.in:5007/api/board/classes-by-bm";
export const boardAndMediumBasedSubjectsAPI =
  "https://web1024.docmaster.in:5007/api/board/linked-subjects/";

// quiz management related urls
export const SCHOOL_QUIZ_API_BASE_URL =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin";
export const SCHOOL_QUIZ_API_BASE_URL_new =
  "https://web1024.docmaster.in:5010/api/school";
